import React from "react";

class Page1 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 1) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      People explore and make choices in different ways. It’s
                      like going to a supermarket. Some people have it all
                      planned out, take a list of what they need and stick to
                      it. Others go with no list but a fair idea of what they
                      like, then see what’s there, what’s on offer, or new
                      things they can try. Both approaches are ok. There’s no
                      right or wrong answer, and it’s the same with your career
                      – the only person who can tell if it feels right is you.{" "}
                      <br />
                      <br />
                      Knowing yourself is one of the most important factors in
                      making choices about your career. Having an idea of your
                      values, strengths, likes and dislikes will help you craft
                      a shopping list of what to look for when exploring
                      opportunities. <br />
                      <br />
                      In this module you will complete two activities. The first
                      one will help you identify your values, also known as your
                      motivators. The second one will help you explore what
                      energises you, these are your strengths.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page1;
